import {setToken,getToken} from '@/tool/cookie'
import {createRoutes} from '@/tool/index'
import router from './router'
import { asyncRoutes } from '@/router'
import Qs from 'qs'
import storage from 'good-storage'

// 路由拦截器
let hasMenus = false // 是否有菜单数据
router.beforeEach((to, from, next) => {
	let token = getToken('token');
	if(token){// 判断是否有token
		if(to.path === '/login'){ // 登录中不能进入登录页面
			//  跳转到首页
			next({ path: '/' })
		}else if(hasMenus){ // 如果已经有菜单了
			next()
		}else{
			// 这里可以用 await 配合请求后台数据来生成路由
			// 动态添加路由
			let login_uid = getToken('login_uid');
			if(login_uid == 1){
				router.addRoutes(asyncRoutes)
			}else{
				// 如果不是超级管理员，获取管理员的权限
				let data1 = JSON.parse(storage.get('manager_role2'));
				// console.log(data1)
				let data2 = createRoutes(asyncRoutes,data1);
				router.addRoutes(data2)
				// console.log(data2)
				// console.log(asyncRoutes[0]['children'][0])
				// console.log(data1[0]['children'][0])
				// let data2 = createRoutes(asyncRoutes,data1);
				// console.log(data2)
				// getManagerRole(Qs.stringify()).then(response => {
				// 	let data = createRoutes(asyncRoutes,response.result);
				// 	router.addRoutes(data)
				// 	// setToken('manager_role',JSON.stringify(data));
				// })
			}
			hasMenus = true
			next({ path: to.path || '/dashboard' })
			
		}
	}else{
		hasMenus = false // 如果重新登录，要重新获取菜单
		if (to.path === '/login') {
		    next()
		} else {
		    next('/login')
		}
	}
});